<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import JsryzxwhBrowse from "./JsryzxwhBrowse";
import JsryzxwhEdit from "./JsryzxwhEdit";
import JsryzxwhForm from "./JsryzxwhForm";
export default {
    name: "jsryzxwh",
    components: { JsryzxwhBrowse, JsryzxwhEdit, JsryzxwhForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "JsryzxwhEdit";
            } else if (this.editProps.showForm === true) {
                return "JsryzxwhForm";
            } else {
                return "JsryzxwhBrowse";
            }
        }
    }
};
</script>
